import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pluginPlatformApi, type PluginRecord } from '../../api/pluginplatform';

export function PluginHealthPage() {
  const [plugins, setPlugins] = useState<PluginRecord[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void pluginPlatformApi.listPlugins().then((r) => setPlugins(r.plugins)).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/plugins" className="text-sm text-blue-600 hover:underline">← Plugin Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Plugin Health Dashboard</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {plugins.map((p) => (
          <li key={p.id} className="flex items-center justify-between rounded border px-4 py-3 dark:border-slate-700">
            <span>{p.name}</span>
            <span className={`rounded px-2 py-0.5 text-sm ${p.health.status === 'up' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {p.health.status}
            </span>
          </li>
        ))}
        {plugins.length === 0 && <li className="text-sm text-slate-500">No installed plugins to monitor.</li>}
      </ul>
    </div>
  );
}
